import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";
import {List} from "immutable";

// Components
import VirtualizedTable from "../../components/common/virtualized-table";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import ProblemsDialog from "../../components/dialogs/ProblemsDialog";

class ProjectProblems extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null
        }
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        })
    };

    render() {

        // Project Work Reports Table
        const tableData = this.props.project.get('problems') || List([]);
        const tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false,
        };
        const tableColumns = {
            date: {
                title: 'Fecha',
                columnType: 'date',
                dataField: 'date',
                width: 100,
                style: { maxWidth: 150 },
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            comments: {
                title: "Comentarios incidencia",
                columnType: 'text',
                dataField: 'comments',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (problemId) => {
                    return (
                        <Icon className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                            this.props.onDeleteProblem(problemId);
                        }} />
                    );
                }
            }
        };

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'problemsDialog':
                    modal = {
                        width: 'large',
                        title: 'Registrar incidencia',
                        body: (
                            <ProblemsDialog
                                onRef={ref => (this.child = ref)}
                                project={this.props.project}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                onRegisterProblem={this.props.onRegisterProblem}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onSaveButtonClick() }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-danger">{tableData.size}</span>
                        <span>Incidencias</span>
                    </div>
                    <div className="col-auto ml-auto ">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.openModal('problemsDialog') }
                        ><Icon icon="insert" />Incidencia</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}


export default ProjectProblems;


// WEBPACK FOOTER //
// ./src/containers/projects/ProjectProblems.js